import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { INotification } from '../../models/notification.model';

export interface INotificationsSlice {
  notifications: INotification[];
}

const initialState: INotificationsSlice = {
  notifications: [],
};

const notificationsSlice = createSlice({
  name: 'assistance',
  initialState,
  reducers: {
    addNotifications(state, action: PayloadAction<{ newNotifications: INotification[] }>) {
      state.notifications = state.notifications.concat(action.payload.newNotifications);
    },
    toggleNotificationSeen(state, action: PayloadAction<{ notificationId: string | number }>) {
      const notificationIndex = state.notifications.findIndex(
        (notification) => notification.id === action.payload.notificationId,
      );
      if (notificationIndex !== -1) {
        state.notifications[notificationIndex].seen = !state.notifications[notificationIndex].seen || true;
      }
    },
  },
});

export const { addNotifications, toggleNotificationSeen } = notificationsSlice.actions;

export default notificationsSlice.reducer;
